import { EmptyURIValue } from '../consts/consts';
import { URIPrefix } from '../enums/url-prefix.enum';
import { IInternalDirectoryLinkItem } from '../models/internal-directory-link.interface';
import { encodeSpecialCharacters } from './fixed-encode-uri-component';

// Same two-pass href encoding DirectoryLinkService uses and sitemap-service mirrors. Changing it
// must match both surfaces or a link and its canonical/sitemap entry diverge.
const slugForHref = (value: string): string => encodeURIComponent(encodeSpecialCharacters(value.toLocaleLowerCase()));

export interface IInternalDirectoryLinkContext {
  stateAbbreviation?: string;
  city?: string;
}

/**
 * Builds the relative directory path for one link item, e.g. `/sta-co/cty-all/spc-anxiety`. State
 * and city segments are always present (`all` when unspecified); a `URIPrefix.CITY` item fills the
 * city segment with no trailing filter.
 */
export function buildInternalDirectoryPath(
  item: IInternalDirectoryLinkItem,
  context: IInternalDirectoryLinkContext = {}
): string {
  const stateSegment = context.stateAbbreviation
    ? context.stateAbbreviation.toLocaleLowerCase()
    : EmptyURIValue;

  if (item.prefix === URIPrefix.CITY) {
    const citySlug = slugForHref(item.urlValue ?? item.label);
    return `/${URIPrefix.STATE}-${stateSegment}/${URIPrefix.CITY}-${citySlug}`;
  }

  const citySegment = context.city ? slugForHref(context.city) : EmptyURIValue;
  const filterValue = slugForHref(item.urlValue ?? item.label);

  return `/${URIPrefix.STATE}-${stateSegment}/${URIPrefix.CITY}-${citySegment}/${item.prefix}-${filterValue}`;
}
